/**
 * Rowie Mega Menu — Global function for Alpine x-data
 */
window.RowieMegaMenu = function() {
  return {
    activePanel: null,
    _closeTimeout: null,
    _openTimeout: null,
    panelOpen: false,

    openDelay: 80,
    closeDelay: 200,

    init() {
      this._escHandler = (e) => {
        if (e.key === 'Escape' && this.panelOpen) {
          this.closePanel();
        }
      };
      document.addEventListener('keydown', this._escHandler);
    },

    destroy() {
      document.removeEventListener('keydown', this._escHandler);
      clearTimeout(this._closeTimeout);
      clearTimeout(this._openTimeout);
    },

    openPanel(panelId) {
      clearTimeout(this._closeTimeout);

      if (this.panelOpen && this.activePanel !== panelId) {
        this.activePanel = panelId;
      } else if (!this.panelOpen) {
        clearTimeout(this._openTimeout);
        this._openTimeout = setTimeout(() => {
          this.activePanel = panelId;
          this.panelOpen = true;
        }, this.openDelay);
      }
    },

    startClose() {
      clearTimeout(this._openTimeout);
      this._closeTimeout = setTimeout(() => {
        this.closePanel();
      }, this.closeDelay);
    },

    cancelClose() {
      clearTimeout(this._closeTimeout);
    },

    closePanel() {
      clearTimeout(this._closeTimeout);
      clearTimeout(this._openTimeout);
      this.activePanel = null;
      this.panelOpen = false;
    },

    isPanelActive(panelId) {
      return this.activePanel === panelId;
    },
  };
};